import React, {FC, useEffect} from 'react';
import {triggerDeclineContractEvent} from 'config/seo/events';
import {Page} from 'containers/common/sections/layout';
import DocumentDeclinedPage from 'containers/common/sections/document-declined/DocumentDeclinedPage';
import {createGetServerSideProps} from 'evcharging/app';
import {I18nPage} from "i18n/types/pages.enum";

const DocumentDeclined: FC = () => {
  useEffect(() => {
    triggerDeclineContractEvent();
  }, []);
  return (
    <Page>
      <DocumentDeclinedPage />
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.DocumentDeclined]);

export default DocumentDeclined;
